import { HttpClient } from '@angular/common/http';
import { Injectable, Signal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { oeeContext } from '../../../core/interceptors/api-interceptor.interceptor';
import { ELoadStatus } from '../../../state/state.interface';
import { EMPTY_ACTION } from '../../../state/user/user.actions';
import { UserEffects } from '../../../state/user/user.effects';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { TScwAppModules } from './scw-app-switcher.interface';

export interface IScwAppSwitcherComponentState {
  data: TScwAppModules;
  dataLoading: ELoadStatus;
}

@Injectable()
export class ScwAppSwitchersStore extends ComponentStore<IScwAppSwitcherComponentState> {
  private static emptyData: TScwAppModules = {
    actionTracker: undefined,
    digitalBoards: undefined,
    digitalLogbook: undefined,
    oeeTracker: undefined,
  };
  readonly isLoading$: Signal<boolean> = this.selectSignal(
    (state: IScwAppSwitcherComponentState) => state.dataLoading === ELoadStatus.loading,
  );
  readonly data$: Signal<TScwAppModules> = this.selectSignal((state: IScwAppSwitcherComponentState) => state.data);

  readonly getUrls = this.effect((trigger$: Observable<void>) =>
    trigger$.pipe(
      switchMap(() => {
        if (!UserEffects.getUser().moduleUrls.oeeTrackerBackendUrl) {
          this.patchState({ data: ScwAppSwitchersStore.emptyData, dataLoading: ELoadStatus.success });

          return EMPTY_ACTION;
        }

        this.patchState({ dataLoading: ELoadStatus.loading });

        return this.getUrlsFromOEE().pipe(
          tapResponse(
            (response) =>
              this.patchState({
                data: response.data,
                dataLoading: ELoadStatus.success,
              }),
            () => {
              this.patchState({ dataLoading: ELoadStatus.failure });
            },
          ),
        );
      }),
    ),
  );

  constructor(private readonly http: HttpClient) {
    super({
      data: ScwAppSwitchersStore.emptyData,
      dataLoading: ELoadStatus.initial,
    });
  }

  private getUrlsFromOEE(): Observable<IBaseResponse<TScwAppModules>> {
    return this.http.get<IBaseResponse<TScwAppModules>>('users/scw-app-module-urls', {
      context: oeeContext,
    });
  }
}
